import moment from 'moment';
import i18n from '@/plugins/i18n';

// import store from '@/globalvar.js'

i18n.locale = localStorage.language ? localStorage.language : i18n.locale;

// initialisation of voiceReco
const isSpeechRecognitionSupported =
    'SpeechRecognition' in window || 'webkitSpeechRecognition' in window;
let recognition = null;
let recognizing = false;

const DefaultDate = '1899-12-30T';

if (isSpeechRecognitionSupported) {
    window.SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    recognition = new window.SpeechRecognition();
    recognizing = false;
}

const fDefaultDate = '1899-12-30T00:00:00'; //1899-12-30 00:00:00.000

const Utils = {
    getFormatComponentDatePicker(type) {
        if (type === 'date') {
            return (localStorage.dateFormat ?? '').trim().toUpperCase() === 'DD/MM/YYYY'
                ? 'DD/MM/YYYY'
                : 'MM/DD/YYYY';
        } else {
            return (localStorage.dateFormat ?? '').trim().toUpperCase() === 'DD/MM/YYYY'
                ? 'DD/MM/YYYY hh:mm A'
                : 'MM/DD/YYYY hh:mm A';
        }
    },

    getLanguageComponentDatePicker() {
        return localStorage.language;
    },

    ValidateDateByFormat(value) {
        if (!value) return false;
        const str =
            typeof value === 'string' ? value : moment(value).format(localStorage.dateFormat);
        return moment(str, localStorage.dateFormat, true).isValid();
    },

    fromApiToDate(dateStr) {
        if (!dateStr) return null;

        const [datePart, timePart] = dateStr.split('T');
        const [year, month, day] = datePart.split('-').map(Number);
        const [hour, min, sec] = timePart.split(':').map(Number);

        var dateResult = new Date(year, month - 1, day, hour, min, sec);

        const pad = n => String(n).padStart(2, '0');

        return (
            dateResult.getFullYear() +
            '-' +
            pad(dateResult.getMonth() + 1) +
            '-' +
            pad(dateResult.getDate()) +
            'T' +
            pad(dateResult.getHours()) +
            ':' +
            pad(dateResult.getMinutes()) +
            ':' +
            pad(dateResult.getSeconds())
        );
    },

    formatToLocalISODate(date) {
        const pad = n => String(n).padStart(2, '0');
        return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(
            date.getHours()
        )}:${pad(date.getMinutes())}`;
    },

    formatToLocalISODateTime(date) {
        const pad = n => String(n).padStart(2, '0');
        return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
    },

    getShortDateFormat() {
        return (localStorage.dateFormat ?? '').trim().toUpperCase() === 'DD/MM/YYYY'
            ? 'DD/MM/YYYY'
            : 'MM/DD/YYYY';
    },

    getDateWithShortYearFormat() {
        return (localStorage.dateFormat ?? '').trim().toUpperCase() === 'DD/MM/YYYY'
            ? 'DD/MM/YY'
            : 'MM/DD/YY';
    },

    getDateTimeFormat() {
        return (localStorage.dateFormat ?? '').trim().toUpperCase() === 'DD/MM/YYYY'
            ? 'DD/MM/YYYY hh:mm A'
            : 'MM/DD/YYYY hh:mm A';
    },

    getFullDateTimeFormat() {
        return (localStorage.dateFormat ?? '').trim().toUpperCase() === 'DD/MM/YYYY'
            ? 'DD/MM/YYYY HH:mm:ss'
            : 'MM/DD/YYYY HH:mm:ss';
    },

    getSchedulerDateTimeFormat() {
        return (localStorage.dateFormat ?? '').trim().toUpperCase() === 'DD/MM/YYYY'
            ? 'dd/MM/yyyy hh:mm a'
            : 'MM/dd/yyyy hh:mm a';
    },

    getMomentLocaleString() {
        return (localStorage.dateFormat ?? '').trim().toUpperCase() === 'DD/MM/YYYY'
            ? 'DD/MM/YYYY HH:mm'
            : 'MM/DD/YYYY HH:mm';
    },

    getDateTimeFormatToIso() {
        return 'YYYY-MM-DDTHH:mm';
    },

    getDateFormatToIso() {
        return 'YYYY-MM-DD';
    },

    HTML2PlainText(HTML) {
        let div = document.createElement('div');
        div.innerHTML = HTML;
        return div.textContent || div.innerText || '';
    },

    getLocale() {
        return new Intl.NumberFormat().resolvedOptions().locale;
    },

    strToTitleCase(str) {
        if (!str) {
            return '';
        }

        return str
            .split(/\s+/)
            .map(word => {
                // Only title-case words containing Latin letters
                if (/[a-z]/i.test(word)) {
                    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
                }
                return word;
            })
            .join(' ');
    },

    arrToTitleCase(response, fieldName) {
        if (!Array.isArray(response)) {
            return [];
        }

        return response.map(item => {
            if (!item) {
                return item;
            }

            item[fieldName] = (item[fieldName] ?? '')
                .split(/\s+/)
                .map(word => {
                    // Only title-case words containing Latin letters
                    if (/[a-z]/i.test(word)) {
                        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
                    }

                    return word;
                })
                .join(' ');

            return item;
        });
    },

    dateIsValid(date) {
        return !Number.isNaN(new Date(date).getTime());
    },

    IsValidFieldDate(date) {
        var valid = false;
        if (date !== undefined && date !== null && date !== '') {
            var arr = date.split('-');
            valid =
                parseInt(arr[0]) > 1900 &&
                parseInt(arr[1]) > 0 &&
                parseInt(arr[1]) <= 12 &&
                parseInt(arr[2]) > 0 &&
                parseInt(arr[2]) <= 31
                    ? true
                    : false;
        }
        return valid;
    },

    formatterSSN(inSSN, outSSN) {
        if (inSSN == null) {
            inSSN = '';
        }
        if (inSSN.length == 2 || inSSN.length == 5) {
            outSSN = outSSN + '-';
        }
        if (inSSN.length == 11) {
            outSSN = outSSN.slice(0, -1);
        }
        return outSSN;
    },

    formatterDate(value, format) {
        if (value) {
            return moment(value, format).format('YYYY-MM-DD');
        } else {
            return null;
        }
    },

    formatterDateIso(value) {
        if (value) {
            return moment(value, this.getShortDateFormat()).format('YYYY-MM-DD');
        } else {
            return null;
        }
    },

    formatterNowToDate() {
        return moment().format('YYYY-MM-DD');
    },

    formatDateTime(value, format) {
        if (value) {
            return moment(value, format).format('YYYY-MM-DD HH:mm:ss');
        } else {
            return null;
        }
    },

    DateIsEmpty(value) {
        return fDefaultDate === value;
    },

    formatterDateToShortLocaleString(value, format) {
        if (value) {
            return moment(value, format)
                .locale(this.getMomentLocaleString())
                .format('ddd, ll');
        } else {
            return null;
        }
    },

    formatterDateToLocaleString(value, format) {
        if (value) {
            return moment(value, format)
                .locale(this.getMomentLocaleString())
                .format('LLLL');
        } else {
            return null;
        }
    },

    formatterDateToString(value, format) {
        if (value) {
            return moment(value, format).format(this.getShortDateFormat());
        }
    },

    formatterToString(value) {
        if (value) {
            const mmt = moment(value);
            var mmtMidnight = mmt.clone().startOf('day');
            var diffMinutes = mmt.diff(mmtMidnight, 'minutes');
            if (diffMinutes == 0) {
                return mmt.format(this.getShortDateFormat());
            }

            return mmt.format(this.getDateTimeFormat());
        }
    },

    isDateFromAndDateTo(DateFrom, DateTo) {
        // Si ambos son null, no hay filtro → válido
        if (DateFrom === null && DateTo === null) return true;

        // Si solo hay fecha desde (sin hasta) → válido
        if (DateFrom !== null && DateTo === null) return true;

        // Si solo hay fecha hasta (sin desde) → válido
        if (DateFrom === null && DateTo !== null) return true;

        // Si ambas tienen valor, validar que desde <= hasta
        const from = Date.parse(DateFrom);
        const to = Date.parse(DateTo);

        if (isNaN(from) || isNaN(to)) return false;
        return from <= to;
    },

    formatterDateTimeToString(value, format) {
        if (value) {
            return moment(value, format).format(this.getDateTimeFormat());
        }
    },

    formatterTimeToString(value, format) {
        if (value) {
            return moment(value, format).format('HH:mm');
        }
    },

    formatterDateTimeAndSecondsToString(value) {
        if (value) {
            return moment(value).format(this.getFullDateTimeFormat());
        }
    },

    formatterToISO(value, format) {
        if (value) {
            return moment(value, format).format('YYYY-MM-DDTHH:mm:ss');
        }

        return null;
    },

    formatterDateIsoWithFormat(value) {
        if (value) {
            return moment(value, this.getDateTimeFormat()).format('YYYY-MM-DDTHH:mm');
        } else {
            return null;
        }
    },

    formatterToISO2(value, format) {
        if (value) {
            return moment(value, format).format('YYYY-MM-DDTHH:mm');
        }

        return null;
    },

    formatDateCustom(value) {
        if (value) {
            return moment(value).format('YYYYMMDD');
        }
    },

    formatTimeCustom(value) {
        if (value) {
            return moment(value).format('HHmmss');
        }
    },

    formatTime(value, format) {
        if (value) {
            return moment(value, format).format('hh:mm A');
        }
    },

    formatTimeWithoutFormat(value) {
        if (value) {
            return moment(value, this.getFullDateTimeFormat()).format('hh:mm A');
        }
    },

    formatTime2(value) {
        //Input format (09:30)
        if (value) {
            return moment(value, 'HH:mm').format('hh:mm A');
        }
    },

    formatTime3(value) {
        //Input format (09:30 AM, output: 09:30)
        if (value) {
            return moment(value, 'hh:mm A').format('HH:mm');
        }
    },

    formatTime4(value, format) {
        if (value) {
            return moment(value, format).format('hh:mm a');
        }
    },

    formatTimeWSec(value) {
        if (value) {
            return moment(value).format('hh:mm:ss A');
        }
    },

    formatTimeHm(value) {
        if (value) {
            return moment(value).format('HH:mm');
        }
    },

    setTimeToDateTime(date, time, format) {
        //return 2018-06-25T20:10:55-04:00 with format param empty
        let timeArr = time.split(':');
        let newDate = new Date(date);
        newDate.setHours(timeArr[0], timeArr[1]);
        return moment(newDate).format(format);
    },

    getCurrentDateTime(format) {
        let currentDateTime = new Date();
        return moment(currentDateTime).format(format);
    },

    ValidateDate(date, format, strict) {
        //if(this.dateIsValid(date)){
        if (this.isValidDate(date, format, strict)) {
            //var ReturnDate = new Date(Date.parse(date)).toISOString();
            var ReturnDate = moment(date, format).toISOString();
            return ReturnDate;
        } else {
            return false;
        }
    },

    isValidDate(date, format, strict) {
        try {
            const newDate = moment(date, format, strict);
            return newDate.isValid();
        } catch {
            return false;
        }
    },

    isValidTime(time) {
        try {
            // 12-hour format without seconds: hh:mm AM/PM
            const short12h = /^(0?[1-9]|1[0-2]):[0-5][0-9]\s?[APap][Mm]$/;

            // 12-hour format with seconds: hh:mm:ss AM/PM
            const long12h = /^(0?[1-9]|1[0-2]):[0-5][0-9]:[0-5][0-9]\s?[APap][Mm]$/;

            // 24-hour format without seconds: HH:mm
            const short24h = /^(?:[01]?[0-9]|2[0-3]):[0-5][0-9]$/;

            // 24-hour format with seconds: HH:mm:ss
            const long24h = /^(?:[01]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$/;

            return (
                short12h.test(time) ||
                long12h.test(time) ||
                short24h.test(time) ||
                long24h.test(time)
            );
        } catch {
            return false;
        }
    },

    CombineDateAndTime(date, time) {
        const timeString = moment(time).format('HH:mm:ss');
        const dateString = moment(date).format('YYYY-MM-DD');

        return moment(`${dateString} ${timeString}`, 'YYYY-MM-DD HH:mm:ss').format(
            'YYYY-MM-DDTHH:mm:ss'
        );
    },

    formatterShortTimeToIso(time, format = 'HH:mm') {
        return moment(time, format).format('YYYY-MM-DDTHH:mm:ss');
    },

    ValidateDateSchedulerEditor(startTime, endTime) {
        let result = true;

        let stTime = moment(startTime).format(this.getFullDateTimeFormat());
        let enTime = moment(endTime).format(this.getFullDateTimeFormat());

        if (stTime === enTime || stTime > enTime) result = false;

        return result;
    },

    isValidDateAndRangeWith(date, min, max, format, strict) {
        let data = this.ValidateDate(date, format, strict);
        if (data && typeof data === 'string') {
            return moment(data).isBetween(min, max);
        } else {
            return false;
        }
    },

    IsValidDateAndRange(date, format, strict) {
        return this.isValidDateAndRangeWith(date, '1899-12-30', '2300-12-30', format, strict);
        //let data = this.ValidateDate(date, format);
        //if (data && (typeof data === 'string')) {
        //    return moment(data).isBetween('1899-12-30', '2300-12-30');
        /*var arr = [];
            if(date){         
                arr = date.includes('/') ? date.split('/') : date.split('-');
            }
            if(arr.length >= 3){
                var m = arr[0];
                var d = arr[1];
                var y = arr[2].split(' ');
                var datefull = y[0]+"-"+m+"-"+d;
                return moment(datefull).isBetween('1899-12-30', '2300-12-30');
            }else{
                return false;
            }*/
        //}
        //else {
        //    return false;
        //}
    },

    getDefaultDate() {
        return DefaultDate;
    },

    convertTo24Hour(time) {
        // 2024-02-12 12:20 am --> 00:20 || 2024-02-12 02:20 pm --> 14:20
        return moment(time, 'YYYY-MM-DD hh:m A').format('HH:mm');
    },

    getType(ext) {
        let result = '';
        switch (ext) {
            case '.JPG':
            case '.PNG':
            case '.TIF':
            case '.TIFF':
            case '.BMP':
            case '.GIF':
            case '.HEIC':
            case '.SVG':
            case '.JPEG':
            case '.WEBP':
            case '.DIB':
            case '.RLE':
            case '.TGA':
            case '.PCX':
            case '.PSD':
            case '.CPT':
            case '.AI':
            case '.PPM':
            case '.CEL':
            case '.PIC':
            case '.RAW':
            case '.DDS':
            case '.PSPIMAGE':
            case '.THM':
            case '.YUV':
            case '.RGB':
            case '.RGBA':
            case '.EPS':
                result = 'graphics';
                break;
            case '.DOCX':
            case '.DOC':
            case '.PAGES':
            case '.TEX':
            case '.WPD':
            case '.WPS':
            case '.MSG':
            case '.LOG':
            case '.TXT':
            case '.RTF':
            case '.ODT':
            case '.DOCM':
            case '.DOTX':
            case '.DOTM':
            case '.DOT':
            case '.PDF':
            case '.INDD':
            case '.PCT':
            case '.PPT':
            case '.PPTX':
            case '.PPS':
            case '.PPSX':
                result = 'documents';
                break;
            case '.ZIP':
            case '.RAR':
            case '.SITX':
            case '.7Z':
            case '.GZ':
            case '.TPSR':
            case '.TAR':
            case '.LZMA':
            case '.MPKG':
            case '.SIFZ':
            case '.FZPZ':
            case '.PUB':
            case '.GZIP':
            case '.LZ4':
            case '.ZLIB':
            case '.LZFSE':
            case '.CBR':
            case '.DEB':
            case '.PKG':
            case '.RPM':
            case '.TAR.GZ':
            case '.ZIPX':
            case '.RTE':
            case '.ICE':
            case '.XAPK':
            case '.SIT':
                result = 'compressed';
                break;
            case '.AIF':
            case '.IFF':
            case '.M3U':
            case '.M4A':
            case '.MID':
            case '.MP3':
            case '.MPA':
            case '.WAV':
            case '.WMA':
            case '.OGG':
                result = 'audio';
                break;
            case '.3G2':
            case '.3GP':
            case '.ASF':
            case '.AVI':
            case '.FLV':
            case '.M4V':
            case '.MOV':
            case '.MP4':
            case '.MPG':
            case '.MKV':
            case '.RM':
            case '.STR':
            case '.SWF':
            case '.VOB':
            case '.WMV':
                result = 'video';
                break;
            case '.3DM':
            case '.3DS':
            case '.MAX':
            case '.OBJ':
            case '.X':
            case '.3DMF':
            case '.OFF':
            case '.C4D':
            case '.LWO':
            case '.LW':
            case '.MA':
            case '.DWG':
            case '.DXF':
                result = 'models';
                break;
            case '.XLR':
            case '.XLS':
            case '.XLSX':
            case '.123':
            case '.GNUMERIC':
            case '.DEX':
            case '.DEF':
            case '.LX':
            case '.NUMBERS':
            case '.NB':
            case '.NUMBERS-TEF':
            case '.PMVX':
            case '.XLTM':
            case '.XLSB':
            case '.SXC':
            case '.ODS':
            case '.IMP':
            case '.MAR':
            case '.BKS':
            case '.EFU':
            case '.OTS':
            case '.PRESTO':
            case '.EDXZ':
            case '.CELL':
            case '.RDF':
            case '.XAR':
            case '._XLS':
            case '.PMD':
            case '.SDC':
            case '.FP':
            case '.WQ2':
            case '._XLSX':
            case '.QPW':
            case '.GSHEET':
            case '.FODS':
            case '.OGWU':
            case '.WKU':
                result = 'spreadsheets';
                break;
            case '.BIN':
            case '.CUE':
            case '.DMG':
            case '.ISO':
            case '.MDF':
            case '.TOAST':
            case '.VCD':
            case '.CSO':
            case '.DAX':
            case '.DMGPART':
            case '.ROM':
            case '.VDI':
            case '.QCOW':
            case '.VMDK':
            case '.IMG':
            case '.DVD':
            case '.MDS':
            case '.DSK':
            case '.D00':
            case '.BWS':
            case '.MBI':
            case '.SDI':
            case '.WLZ':
            case '.I02':
            case '.L01':
            case '.NRG':
            case '.MD0':
            case '.DAA':
            case '.DCF':
            case '.IMA':
            case '.TIB':
            case '.OMG':
            case '.UIF':
            case '.CISO':
            case '.UDF':
            case '.IMAGE':
            case '.MD2':
            case '.IBDAT':
                result = 'diskimages';
                break;
            default:
                result = 'unknown';
        }
        return result;
    },

    generateUUID() {
        // Public Domain/MIT
        let d = new Date().getTime(); //Timestamp
        let d2 =
            (typeof performance !== 'undefined' && performance.now && performance.now() * 1000) ||
            0; //Time in microseconds since page-load or 0 if unsupported
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            let r = Math.random() * 16; //random number between 0 and 16
            if (d > 0) {
                //Use timestamp until depleted
                r = (d + r) % 16 | 0;
                d = Math.floor(d / 16);
            } else {
                //Use microseconds since page-load if supported
                r = (d2 + r) % 16 | 0;
                d2 = Math.floor(d2 / 16);
            }
            return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
        });
    },

    ValidateEmail(email) {
        var re = /\S+@\S+\.\S+/;
        return re.test(email);
    },

    HaveChangesSelected(arr1, arr2) {
        if (arr1.length !== arr2.length) {
            return false;
        }
        for (let i = 0; i < arr1.length; i++) {
            if (arr1[i].selected !== arr2[i].selected) {
                return false;
            }
        }
        return true;
    },

    generateRecID() {
        let d = new Date().getTime();
        let d2 =
            (typeof performance !== 'undefined' && performance.now && performance.now() * 1000) ||
            0;
        return 'xxxxxxxxxxxxxxxy'.replace(/[xy]/g, function(c) {
            let r = Math.random() * 16;
            if (d > 0) {
                r = (d + r) % 16 | 0;
                d = Math.floor(d / 16);
            } else {
                r = (d2 + r) % 16 | 0;
                d2 = Math.floor(d2 / 16);
            }
            return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
        });
    },

    validateBirthDate(date) {
        const birthDate = moment(date, 'YYYY-MM-DD');
        if (!birthDate.isValid()) {
            return false;
        }
        const birthDateYear = birthDate.year();
        const birthDateMonth = birthDate.month() + 1;
        const birthDateDay = birthDate.date();
        const currentDate = moment();
        const currentYear = currentDate.year();
        const currentMonth = currentDate.month() + 1;
        const currentDay = currentDate.date();
        if (
            birthDateYear > currentYear ||
            (birthDateYear === currentYear && birthDateMonth > currentMonth) ||
            (birthDateYear === currentYear &&
                birthDateMonth === currentMonth &&
                birthDateDay > currentDay)
        ) {
            return false;
        }
        return true;
    },
    toggleSpeechBar() {
        if (isSpeechRecognitionSupported) {
            var speechBar = document.getElementById('speechBar');
            if (speechBar.classList.contains('active')) {
                speechBar.classList.remove('active');
            } else {
                speechBar.classList.add('active');
            }
        }
    },
    stopSpeechToText() {
        var self = this;
        if (isSpeechRecognitionSupported) {
            self.toggleSpeechBar();
            recognizing = false;
            recognition.stop();
        }
    },

    startSpeechToText(elemId) {
        if (elemId) {
            var self = this;
            // Stop voice reconigtion if is on
            // self.stopSpeech();

            if (isSpeechRecognitionSupported) {
                recognition.lang = i18n.locale;
                recognition.continuous = true;
                recognition.interimResults = true;
                recognition.maxAlternatives = 1;
                var elemById = document.getElementById(elemId);

                recognition.onend = () => {
                    if (recognizing) {
                        self.toggleSpeechBar();
                    }
                    recognizing = false;
                };

                recognition.onresult = event => {
                    if (typeof event.results === 'undefined') {
                        recognizing = false;
                        recognition.stop();
                        return;
                    }
                    for (var i = event.resultIndex; i < event.results.length; ++i) {
                        if (event.results[i].isFinal) {
                            // let finalSentence = event.results[i][0].transcript;
                            // elemById.value += (this.capitalizeFirstLetter(finalSentence));
                            elemById.value += Array.from(event.results[i][0].transcript).join('');
                            //simulation of trigger keypress
                            elemById.dispatchEvent(
                                new Event('input', { bubbles: true, cancelable: true })
                            );
                            elemById.dispatchEvent(new Event('change'));
                        }
                    }
                };
                if (!recognizing) {
                    recognition.start();
                    recognizing = true;
                } else {
                    recognition.stop();
                    recognizing = false;
                }
            }
        } else {
            return;
        }
    },
    capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    },
    startSpeech(elemId) {
        if (elemId) {
            var self = this;
            // Stop voice reconigtion if is on
            if (recognizing) {
                self.stopSpeechToText();
            }
            var elemById = document.getElementById(elemId);
            if (isSpeechRecognitionSupported && elemById.value.length > 0) {
                if (speechSynthesis.speaking) {
                    // SpeechSyn is currently speaking, cancel the current utterance(s)
                    speechSynthesis.cancel();
                } else {
                    // Good to go
                    var binding = new SpeechSynthesisUtterance(elemById.value);
                    binding.lang = i18n.locale;
                    speechSynthesis.speak(binding);

                    binding.onend = () => {
                        self.stopSpeech();
                    };
                }
            }
        } else {
            return;
        }
    },
    stopSpeech() {
        var self = this;
        // Stop voice reconigtion if is on
        if (isSpeechRecognitionSupported) {
            self.toggleSpeechBar();
            // SpeechSyn is currently speaking, cancel the current utterance(s)
            speechSynthesis.cancel();
        }
    },

    /* getBrowserLanguage() {
        // Get the user's preferred languages from the browser
        const languages = navigator.languages || [navigator.language]; 

        // Return the first language (most preferred)
        return languages[0]; 
    },

    useBrowserBuildItCalendar() {
        const dateFormat = this.getShortDateFormat().toUpperCase();
        const lang = localStorage.language.toLowerCase();
        const browser = this.getBrowserLanguage().toLowerCase().split('-');
        return (lang == browser[0]) &&
            ((lang === 'es' && dateFormat === 'DD/MM/YYYY') || (lang !== 'es' && dateFormat === 'MM/DD/YYYY'));
    },*/

    getBrowserLanguage() {
        if (typeof navigator !== 'undefined') {
            const languages =
                navigator.languages && navigator.languages.length
                    ? navigator.languages
                    : [navigator.language || 'en'];
            return languages[0] || 'en';
        }
        return 'en';
    },

    useBrowserBuildItCalendar() {
        const dateFormat = (this.getShortDateFormat?.() || '').toUpperCase();

        const storedLang =
            (typeof localStorage !== 'undefined' && localStorage.getItem('language')) || 'en';
        const lang = storedLang.toLowerCase();

        const browserLang = this.getBrowserLanguage().toLowerCase();
        const browserLangCode = browserLang.split('-')[0]; // e.g., 'en' from 'en-US'

        return (
            lang === browserLangCode &&
            ((lang === 'es' && dateFormat === 'DD/MM/YYYY') ||
                (lang !== 'es' && dateFormat === 'MM/DD/YYYY'))
        );
    },

    diffBetween(startTimeStr, endTimeStr, format, unitOfTime, showFractionary = false) {
        if (Utils.isValidTime(startTimeStr) && Utils.isValidTime(endTimeStr)) {
            const start = moment(startTimeStr, format);
            const end = moment(endTimeStr, format);

            if (!showFractionary) {
                return end.diff(start, unitOfTime);
            }

            const diffMs = end.diff(start);
            const unitMs = {
                hours: 3600000,
                hour: 3600000,
                minutes: 60000,
                minute: 60000,
                seconds: 1000,
                second: 1000
            };

            if (!unitMs[unitOfTime]) return 0;

            const result = diffMs / unitMs[unitOfTime];
            return Math.round(result * 100) / 100;
        }

        return 0;
    },

    isNullOrEmptyString(str) {
        if (str && typeof str === 'string') {
            return str.trim().length == 0;
        }

        return true;
    },

    isBoolean(val) {
        const boolValuesRegex = /true|false|1|0|on|off/; // Add other /true|false|1|0|on|off/
        if (val === undefined || val === null) return false;
        return boolValuesRegex.test(val.toString().toLowerCase());
    },

    equalsIgnoringCase(text, other) {
        return text.localeCompare(other, undefined, { sensitivity: 'base' }) === 0;
    },

    toDate(value, format) {
        return moment(value, format).toDate();
    },

    toMidnight(value, format) {
        if (value) {
            const mmt = moment(value, format);
            return mmt
                .clone()
                .startOf('day')
                .toDate();
        }

        return value;
    },

    convertIntegerMask(delphiMask) {
        // Match only integer masks (no decimal point)
        const match = delphiMask.match(/^!([9]+);1;_$/);
        if (!match) return ''; // Not a valid integer mask

        const intPart = match[1]; // string of 9's
        return '#'.repeat(intPart.length); // replace each 9 with #
    },

    removeDuplicateString(arr, options = {}) {
        const { ignoreCase = false, logErrors = false } = options;

        if (!Array.isArray(arr)) {
            if (logErrors) console.error('The received value is not an array.');
            return arr;
        }

        if (!arr.every(item => typeof item === 'string')) {
            if (logErrors) console.error('The array contains elements that are not strings.');
            return arr;
        }

        if (ignoreCase) {
            const seen = new Set();
            return arr.filter(item => {
                const key = item.toLowerCase();
                if (seen.has(key)) return false;
                seen.add(key);
                return true;
            });
        }

        return [...new Set(arr)];
    },

    isValidJSON(item) {
        let value = typeof item !== 'string' ? JSON.stringify(item) : item;
        try {
            value = JSON.parse(value);
        } catch (e) {
            return false;
        }

        return typeof value === 'object' && value !== null;
    },

    isValidNumber(value) {
        if (value === null || value === undefined || value === '') {
            return false;
        }

        const num = typeof value === 'string' ? parseFloat(value) : value;

        if (isNaN(num)) {
            return false;
        }

        return num > 0;
    },

    /**
     * Combina dos objetos dando prioridad al segundo (priorityObj).
     * - Todas las propiedades de priorityObj estarán en el resultado.
     * - Se añaden las propiedades de baseObj que no existan en priorityObj.
     *
     * @param {Object} baseObj - Objeto base (ej: newItem).
     * @param {Object} priorityObj - Objeto con prioridad (ej: handlerResult).
     * @returns {Object} Objeto combinado.
     */
    mergeWithPriority(baseObj, priorityObj) {
        const safePriority = priorityObj || {}; // evita null/undefined
        return {
            ...safePriority,
            ...Object.fromEntries(Object.entries(baseObj).filter(([key]) => !(key in safePriority)))
        };
    },

    formatterCurrent(value) {
        const formatter = new Intl.NumberFormat(navigator.language, {
            style: 'currency',
            currency: 'USD'
        });

        const options = formatter.resolvedOptions();
        return new Intl.NumberFormat(navigator.language, {
            style: 'currency',
            currency: options.currency
        }).format(value);
    },

    getBase64MimeType(base64String) {
        const match = /^data:(image\/[a-zA-Z0-9.+-]+);base64/.exec(base64String);
        return match ? match[1] : null;
    },

    getBase64MimeTypeExtension(base64String) {
        const mime = this.getBase64MimeType(base64String);

        if (mime) {
            const extension = mime.split('/')[1];
            return extension;
        }

        return null;
    },

    parseBase64Image(base64) {
        if (!base64) return { img: '', ext: '' };

        const [header, body] = base64.split(',');

        return {
            img: body || '',
            ext: header ? this.getBase64MimeTypeExtension(header) : ''
        };
    },

    validateDateRange(fromDate, toDate) {
        const invalidFields = [];
        if (!fromDate) invalidFields.push('fromDate');
        if (!toDate) invalidFields.push('toDate');

        if (invalidFields.length > 0) {
            return {
                valid: false,
                fields: invalidFields,
                message: 'Msg.CheckRequiredFields'
            };
        }

        const from = new Date(fromDate);
        const to = new Date(toDate);

        if (isNaN(from.getTime())) invalidFields.push('fromDate');
        if (isNaN(to.getTime())) invalidFields.push('toDate');

        if (invalidFields.length > 0) {
            return {
                valid: false,
                fields: invalidFields,
                message: 'Msg.InvalidField'
            };
        }

        if (from > to) {
            return {
                valid: false,
                fields: ['fromDate', 'toDate'],
                message: 'Shared.DateFromGreater'
            };
        }

        return { valid: true };
    },
    compareDate(a, b, format) {
        return moment(a, format) < moment(b, format);
    },
    splitOrEmpty(str, separator) {
        return str ? str.split(separator) : [];
    },
    isExpired(a) {
        if (!a) {
            return false;
        }

        const from = new Date(a);

        if (isNaN(from.getTime())) {
            return false;
        }

        return this.toMidnight(a) < this.toMidnight(new Date());
    }
};

export default Utils;
